<template>
    <div class="main" v-loading="carregando">
        <c-panel title="VALORES FIXOS DA FOLHA" titleIcon="fas fa-thumbtack">

            <el-form label-position="top" class="u-mb-10">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="14" :md="14">
                        <el-form-item label="Servidor">
                            <el-input :value="servidor.nome" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5" :md="5">
                        <el-form-item label="Nr. Registro">
                            <el-input :value="servidor.registro" disabled></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="5" :md="5">
                        <el-form-item label=" ">
                            <el-button @click="voltar" plain icon="el-icon-back" style="width: 100%;">VOLTAR</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>

            <el-alert type="info" :closable="false" class="u-mb-15"
                title="O que for preenchido aqui abre a grade da aba Folha já com o valor, mês a mês."
                description="O usuário pode alterar o valor dentro da competência — inclusive apagá-lo — sem mexer nesta configuração. Deixar o campo em branco aqui remove o valor fixo do evento."></el-alert>

            <el-alert v-for="(aviso, i) in avisos" :key="i" type="warning" :closable="false" class="u-mb-10" :title="aviso"></el-alert>

            <div class="container-table">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th style="width: 80px;">Código</th>
                            <th>Evento</th>
                            <th style="width: 100px;" class="u-text-center">Digitação</th>
                            <th style="width: 140px;">Valor fixo</th>
                            <th style="width: 90px;" class="u-text-center" title="Desmarcado, o valor fica guardado mas não preenche a grade">Ativo</th>
                            <th>Observação</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in itens" :key="item.evento_cod">
                            <td>{{ item.evento_cod }}</td>
                            <td>{{ item.descricao }}</td>
                            <td class="u-text-center">{{ rotuloTipo(item.tipo_lancamento) }}</td>
                            <td>
                                <el-input v-model="item.texto" :placeholder="placeholder(item)"
                                    @input="digitar(item)" @blur="formatar(item)" size="small"></el-input>
                            </td>
                            <td class="u-text-center">
                                <el-checkbox v-model="item.situacao" :disabled="!item.texto"></el-checkbox>
                            </td>
                            <td>
                                <el-input v-model="item.observacao" size="small" maxlength="120"
                                    placeholder="Opcional" :disabled="!item.texto"></el-input>
                            </td>
                        </tr>
                        <tr v-if="!carregando && !itens.length">
                            <td colspan="6" class="u-text-center">Nenhum evento configurado para a grade.</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="u-text-right u-mt-15">
                <el-button plain icon="el-icon-refresh-left" @click="carregar" :disabled="salvando">DESCARTAR</el-button>
                <el-button type="primary" icon="el-icon-check" @click="salvar" :loading="salvando">SALVAR</el-button>
            </div>

        </c-panel>
    </div>
</template>

<script>
export default {
    name: 'FolhaPontoValorFixoForm',

    data: () => ({
        carregando: false,
        salvando: false,
        servidor: { registro: '', nome: '' },
        itens: [],
        avisos: [],
        configTelas: {}
    }),

    created () {
        this.getConfig()
        this.carregar()
    },

    computed: {
        /**
         * Em dias a fração só existe quando o meio período é representado pela
         * metade da quantidade — mesma regra da grade de lançamento.
         */
        fracaoEmDias () {
            return this.configTelas.meio_dia && this.configTelas.meio_dia !== 'flag'
        }
    },

    methods: {
        baseUrl () {
            return `${this.$store.state.config.baseUrlApi}/api/folha-ponto`
        },

        registro () {
            return this.$route.params.registro
        },

        getConfig () {
            this.$axios.get(`${this.baseUrl()}/configuracao/telas`, this.$store.getters.getHeaderAuth)
                .then(res => { this.configTelas = res.data || {} })
                .catch(() => {})
        },

        carregar () {
            this.carregando = true

            this.$axios.get(`${this.baseUrl()}/valor-fixo/${this.registro()}`, this.$store.getters.getHeaderAuth)
                .then(res => {
                    const d = res.data || {}

                    this.servidor = d.servidor || { registro: '', nome: '' }
                    this.avisos = d.avisos || []

                    this.itens = (d.itens || []).map(i => Object.assign({}, i, {
                        texto: this.formataValor(i.quantidade, i.fracao, i.tipo_lancamento),
                        observacao: i.observacao || ''
                    }))

                    this.carregando = false
                })
                .catch(e => { this.carregando = false; this.$store.commit('throwException', e) })
        },

        voltar () {
            this.$router.push('/admin/folha-ponto/valor-fixo')
        },

        rotuloTipo (tipo) {
            if (tipo === 'H') return 'Horas'
            if (tipo === 'D') return 'Dias'
            return 'Valor'
        },

        /* ---------------------------------------------------------------- */
        /* Máscara — a mesma da grade de lançamento, para o RH digitar igual  */
        /* ---------------------------------------------------------------- */

        digitosDoCampo (tipo) {
            return tipo === 'H' ? 5 : 8
        },

        temFracao (tipo) {
            if (tipo === 'D') return this.fracaoEmDias
            return true
        },

        placeholder (item) {
            if (item.tipo_lancamento === 'H') return '000:00'
            return this.temFracao(item.tipo_lancamento) ? '0,00' : '0'
        },

        /** 4370 -> 4.370 */
        milhar (inteiro) {
            const limpo = String(inteiro).replace(/^0+(?=\d)/, '')
            return limpo.replace(/\B(?=(\d{3})+(?!\d))/g, '.')
        },

        /** Posicional: os dígitos entram pela direita e empurram os anteriores. */
        aplicarMascara (tipo, valor) {
            const digitos = String(valor === null || valor === undefined ? '' : valor)
                .replace(/\D/g, '')
                .slice(-this.digitosDoCampo(tipo))

            if (!digitos) return ''

            if (tipo === 'H') {
                const d = digitos.padStart(5, '0')
                return `${d.slice(0, 3)}:${d.slice(3)}`
            }

            if (!this.temFracao(tipo)) return this.milhar(digitos)

            const d = digitos.padStart(3, '0')
            return `${this.milhar(d.slice(0, -2))},${d.slice(-2)}`
        },

        formataValor (quantidade, fracao, tipo) {
            if (!quantidade && !fracao) return ''
            if (tipo === 'H') return `${String(quantidade).padStart(3, '0')}:${String(fracao).padStart(2, '0')}`
            if (!this.temFracao(tipo) && !fracao) return this.milhar(String(quantidade))

            return `${this.milhar(String(quantidade))},${String(fracao).padStart(2, '0')}`
        },

        interpretaValor (texto, tipo) {
            const digitos = String(texto === null || texto === undefined ? '' : texto).replace(/\D/g, '')

            if (!digitos) return { quantidade: 0, fracao: 0 }

            const recorte = digitos.slice(-this.digitosDoCampo(tipo))

            if (!this.temFracao(tipo)) {
                return { quantidade: parseInt(recorte, 10) || 0, fracao: 0 }
            }

            const d = recorte.padStart(3, '0')
            const fracao = parseInt(d.slice(-2), 10) || 0
            const quantidade = parseInt(d.slice(0, -2), 10) || 0

            // 000:75 digitado vira 001:15 ao sair do campo
            if (tipo === 'H') {
                return { quantidade: quantidade + Math.floor(fracao / 60), fracao: fracao % 60 }
            }

            return { quantidade, fracao }
        },

        digitar (item) {
            item.texto = this.aplicarMascara(item.tipo_lancamento, item.texto)

            // Campo esvaziado deixa de ser valor fixo: a linha some no salvamento,
            // e manter "ativo" desmarcado seria um estado sem sentido ao voltar.
            if (!item.texto) item.situacao = true
        },

        formatar (item) {
            const v = this.interpretaValor(item.texto, item.tipo_lancamento)
            item.texto = this.formataValor(v.quantidade, v.fracao, item.tipo_lancamento)
        },

        salvar () {
            this.salvando = true

            const itens = this.itens.map(i => {
                const v = this.interpretaValor(i.texto, i.tipo_lancamento)

                return {
                    evento_cod: i.evento_cod,
                    tipo_lancamento: i.tipo_lancamento,
                    quantidade: v.quantidade,
                    fracao: v.fracao,
                    situacao: i.situacao,
                    observacao: i.observacao
                }
            })

            this.$axios.post(`${this.baseUrl()}/valor-fixo/salvar`,
                { servidor_cod: this.registro(), itens }, this.$store.getters.getHeaderAuth)
                .then(() => {
                    this.salvando = false
                    window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
                    this.carregar()
                })
                .catch(e => { this.salvando = false; this.$store.commit('throwException', e) })
        }
    }
}
</script>
